const isValid = (v) => v !== undefined && v !== null && v !== "";

const waitForWE = (cb) => {
  if (window.webengage && window.webengage.user) return cb();
  setTimeout(() => waitForWE(cb), 100);
};

const buildAttributes = (user) => {
  const consentDate = new Date();
  const attributes = {
    we_first_name: user.first_name,
    we_phone: user.isd_code && user.phone ? `${user.isd_code}${user.phone}` : undefined,
    we_whatsapp_opt_in: true,
    we_sms_opt_in: true,
    we_email_opt_in: true,

    user_type: "Student",
    grade: Number(user.grade_id),
    genius_school_id: String(user.school_id),

    target_exam: user.exam,
    product_vertical: "Genius",
    product_source: "Learn",

    lead_source: "Genius",

    uam_id: Number(user.uam_id),
    genius_admission_id: user.admission_id,
    udise_code: user.udise_code ? String(user.udise_code) : undefined,
    is_sri_chaitanya_student: false,

    last_consent_date: consentDate
  };

  const filtered = {};
  Object.keys(attributes).forEach((k) => {
    if (isValid(attributes[k])) {
      filtered[k] = attributes[k];
    }
  });

  return filtered;
};

export const webengageLogin = (user) => {
  if (!user?.admission_id) return;

  waitForWE(() => {
    window.webengage.user.login(user.admission_id);

    const payload = buildAttributes(user);
    console.log("WebEngage Login Payload:", payload);

    window.webengage.user.setAttribute(payload);
  });
};

export const webengageRegister = (user) => {
  if (!user?.admission_id) return;

  waitForWE(() => {
    window.webengage.user.login(user.admission_id);

    const payload = buildAttributes(user);
    console.log("WebEngage Register Payload:", payload);

    window.webengage.user.setAttribute(payload);

    window.webengage.track("user_registered", {
      registration_source: user.registration_source || "unknown",
      method: "otp",
      grade: Number(user.grade_id)
    });
  });
};

export const trackReportPageViewed = (examName, user, reportData, examdetailes) => {
  if (!examName) {
    console.warn("[WebEngage] test.report_viewed: test_name is required");
    return;
  }

  if (!user?.admission_id) {
    console.warn("[WebEngage] test.report_viewed: user details not available");
    return;
  }

  waitForWE(() => {
    window.webengage.user.login(user.admission_id);
    const payload = buildAttributes(user);

    const getCurrentLocalTimestamp = () => {
      const now = new Date();
      const isdCode = user?.isd_code || "";

      if (isdCode === "+91") {
        return new Date(now.getTime() + 5.5 * 60 * 60 * 1000).toISOString();
      } else if (isdCode === "+971") {
        return new Date(now.getTime() + 4 * 60 * 60 * 1000).toISOString();
      }
      return now.toISOString();
    };

    const eventData = {
      name: user.first_name,
      grade: Number(user.grade_id),
      test_name: examName,
      test_type: examdetailes?.title || examName,
      number_of_questions: reportData?.total_questions || 0,
      attempted_questions: (reportData?.correct_answers || 0) + (reportData?.incorrect_answers || 0),
      total_marks: reportData?.maximum_marks || 0,
      marks_scored: reportData?.marks_obtained || 0,
      test_datetime: examdetailes?.event_date || examdetailes?.examStartedAt || new Date().toISOString(),
      report_view_datetime: getCurrentLocalTimestamp(),
      report_gen_datetime: getCurrentLocalTimestamp(),
      product_source: "Genius",
      product_vertical: "Learn"
    };

    console.log("[WebEngage] test.report_viewed event:", eventData);
    window.webengage.track("test.report_viewed", eventData);
  });
};

export const trackGatedReport = (examName, user, grade) => {
  if (!examName) {
    console.warn("[WebEngage] clicks.button_clicked: exam_name is required");
    return;
  }

  if (!user?.admission_id) {
    console.warn("[WebEngage] clicks.button_clicked: user details not available");
    return;
  }

  waitForWE(() => {
    window.webengage.user.login(user.admission_id);

    const eventData = {
      interaction_element: "Talk to Expert",
      button_name: "Book a Demo",
      button_section: "Genius_Advanced_Report",
      grade: Number(user.grade_id),
      product_source: "Genius",
      product_vertical: "Learn"
    };

    console.log("[WebEngage] clicks.button_clicked event:", eventData);
    window.webengage.track("clicks.button_clicked", eventData);
  });
};
